module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("h5P0h"))).then(() => parcelRequire('dJXJK'));